const tintColor = "rgb(255, 255, 255)"

const appColor = "rgb(250, 0, 80)"
const appLightColor = "rgba(250, 0, 80, 0.5)"

const activeTintColor = "rgb(255, 255, 255)"
const inActiveTintColor = "rgba(255, 255, 255, 0.6)"

const activeDotColor = "rgb(250, 0, 80)"
const inActiveDotColor = "rgb(104, 112, 118)"

const activeIconColor = "rgb(255, 255, 255)"
const inActiveIconColor = "rgba(255, 255, 255, 0.6)"

interface ColorsType {
    [key: string]: {[key: string]: string}
}

export const Colors: ColorsType = {
    light: {
        app: appColor,
        appLight: appLightColor,

        activeTint: activeTintColor,
        inActiveTint: inActiveTintColor,

        activeDot: activeDotColor,
        inActiveDot: inActiveDotColor,

        activeIcon: activeIconColor,
        inActiveIcon: inActiveIconColor,

        activeBackground: "rgb(240, 240, 240)",
        inActiveBackground: "rgb(210, 210, 210)",

        text: "rgb(70, 70, 70)",
        textLight: "rgb(100, 100, 100)",
        textLighter: "rgb(120, 120, 120)",

        reverseText: "rgb(255, 255, 255)",
        reverseTextLight: "rgb(170, 170, 170)",
        reverseTextLighter: "rgb(120, 120, 120)",

        whiteText: "rgb(255, 255, 255)",
        whiteTextLight: "rgb(170, 170, 170)",
        whiteTextLighter: "rgb(120, 120, 120)",

        blackText: "rgb(70, 70, 70)",
        blackTextLight: "rgb(100, 100, 100)",
        blackTextLighter: "rgb(120, 120, 120)",

        border: 'rgb(150, 150, 150)',
        borderLight: 'rgb(200, 200, 200)',
        borderLighter: 'rgb(230, 230, 230)',

        background: "rgb(225, 225, 225)",
        secondBackground: "rgb(240, 240, 240)",
        thirdBackground: "rgb(255, 255, 255)",

        reverseBackground: "rgb(24, 24, 24)",
        reverseSecondBackground: "rgb(48, 48, 48)",
        reverseThirdBackground: "rgb(72, 72, 72)",

        tint: tintColor,
        icon: "rgb(104, 112, 118)",
        tabIconDefault: "rgb(104, 112, 118)",
        tabIconSelected: tintColor,

        rate: "rgb(255, 207, 141)",

        online: 'rgb(0, 200, 0)',
        offline: 'rgb(0, 100, 0)',

        white: "rgb(255, 255, 255)",
        black: 'rgb(0, 0, 0)',
        red: 'rgb(255, 0, 0)',
        redLight: 'rgba(255, 0, 0, 0.5)',
        redGradient: 'rgb(255, 0, 0)',
        green: 'rgb(83, 167, 41)',
        greenLight: 'rgba(83, 167, 41, 0.5)',
        greenGradient: 'rgb(0, 255, 0)',
        blue: 'rgb(50, 147, 203)',
        blueLight: 'rgba(50, 147, 203, 0.5)',
        blueGradient: 'rgb(0, 160, 255)',
        orange: 'rgb(255, 159, 28)',
        orangeLight: 'rgba(255, 159, 28, 0.5)',
        disabled: 'rgb(90, 90, 90)',

        infoBackgroundActive: 'rgba(0, 0, 0, 0.5)',
        infoBackground: 'rgba(0, 0, 0, 0.4)',
        iconBackground: 'rgba(0, 0, 0, 0.2)',
        shadow: 'rgba(0, 0, 0, 0.3)',
    },
    dark: {
        app: appColor,
        appLight: appLightColor,

        activeTint: activeTintColor,
        inActiveTint: inActiveTintColor,

        activeDot: activeDotColor,
        inActiveDot: inActiveDotColor,

        activeIcon: activeIconColor,
        inActiveIcon: inActiveIconColor,

        activeBackground: "rgb(255, 255, 255)",
        inActiveBackground: "rgb(100, 100, 100)",

        text: "rgb(255, 255, 255)",
        textLight: "rgb(170, 170, 170)",
        textLighter: "rgb(120, 120, 120)",

        reverseText: "rgb(70, 70, 70)",
        reverseTextLight: "rgb(100, 100, 100)",
        reverseTextLighter: "rgb(120, 120, 120)",

        whiteText: "rgb(255, 255, 255)",
        whiteTextLight: "rgb(170, 170, 170)",
        whiteTextLighter: "rgb(120, 120, 120)",

        blackText: "rgb(70, 70, 70)",
        blackTextLight: "rgb(100, 100, 100)",
        blackTextLighter: "rgb(120, 120, 120)",

        border: "rgb(150, 150, 150)",
        borderLight: 'rgb(100, 100, 100)',
        borderLighter: 'rgb(70, 70, 70)',

        background: "rgb(24, 24, 24)",
        secondBackground: "rgb(36, 36, 36)",
        thirdBackground: "rgb(48, 48, 48)",

        reverseBackground: "rgb(255, 255, 255)",
        reverseSecondBackground: "rgb(240, 240, 240)",
        reverseThirdBackground: "rgb(225, 225, 225)",

        tint: tintColor,
        icon: "rgb(155, 161, 166)",
        tabIconDefault: "rgb(155, 161, 166)",
        tabIconSelected: tintColor,

        rate: "rgb(255, 207, 141)",

        online: 'rgb(0, 200, 0)',
        offline: 'rgb(0, 100, 0)',

        white: "rgb(255, 255, 255)",
        black: 'rgb(0, 0, 0)',
        red: 'rgb(255, 0, 0)',
        redLight: 'rgba(255, 0, 0, 0.5)',
        redGradient: 'rgb(255, 0, 0)',
        green: 'rgb(83, 167, 41)',
        greenLight: 'rgba(83, 167, 41, 0.5)',
        greenGradient: 'rgb(0, 255, 0)',
        blue: 'rgb(50, 147, 203)',
        blueLight: 'rgba(50, 147, 203, 0.5)',
        blueGradient: 'rgb(0, 160, 255)',
        orange: 'rgb(255, 159, 28)',
        orangeLight: 'rgba(255, 159, 28, 0.5)',
        disabled: 'rgb(90, 90, 90)',

        infoBackgroundActive: 'rgba(0, 0, 0, 0.5)',
        infoBackground: 'rgba(0, 0, 0, 0.4)',
        iconBackground: 'rgba(0, 0, 0, 0.2)',
        shadow: 'rgba(255, 255, 255, 0.3)',
    },
}
